// import { useEffect, useState } from "react";
// import {
//     Box,
//     Paper,
//     Stepper,
//     Step,
//     StepLabel,
//     Typography,
// } from "@mui/material";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import StepCompanyDetails from "./StepCompanyDetails.tsx";
// import StepBusinessCategory from "./StepBusinessCategory.tsx";
// import StepBusinessDetails from "./StepBusinessDetails.tsx";
// import StepBrand from "./StepBrand.tsx";
// import { AiActions } from "../../Services/_actions/index.js";
// import { useNavigate } from "react-router";
// const STEPS = ["Company Details", "Business Category", "Business Details", "Brand"];

// const INITIAL_DATA = {
//     companyName: "",
//     industry: "",
//     website: "",
//     description: "",
//     logoPreview: null,
//     logoUrl: null,
//     sector: null,
//     sectorId: null,
//     subSector: null,
//     subSectorId: null,
//     category: null,
//     businessType: null,
//     numEmployees: null,
//     licenseType: null,
//     endCustomerType: null,
//     brandColor: "#4962E5",
//     brandFont: "",
//     brandTone: null,
//     platformIntent: "",
// };

// export default function MachadaloStudioDashboard({ onComplete }) {
//     const navigate = useNavigate();
//     const [activeStep, setActiveStep] = useState(0);
//     const [formData, setFormData] = useState(INITIAL_DATA);
//     const [isFetching, setIsFetching] = useState(false);
//     const action = AiActions();
//     const [recordExists, setRecordExists] = useState(null);
//     const userInfo =
//         localStorage.getItem("userInfo");

//     const parsedUser = userInfo
//         ? JSON.parse(userInfo)
//         : null;

//     const organisationId =
//         parsedUser?.profile?.organisation
//             ?.organisation_id || "";

//     // useEffect(() => {
//     //     if (recordExists === true && !isFetching) {
//     //         navigate('/r/machadalostudio/ai');
//     //     }
//     // }, [recordExists, isFetching]);

//     const updateData = (fields) =>
//         setFormData((prev) => {
//             const nextFields =
//                 typeof fields === "function"
//                     ? fields(prev)
//                     : fields;

//             return { ...prev, ...nextFields };
//         });
//     const next = () => setActiveStep((s) => s + 1);
//     const back = () => setActiveStep((s) => s - 1);

//     const stepProps = {
//         formData,
//         updateData,
//         onNext: next,
//         onBack: back,
//         isFetching,
//         recordExists,
//         setRecordExists,
//     };

//     const renderStep = () => {
//         switch (activeStep) {
//             case 0: return <StepCompanyDetails {...stepProps} />;
//             case 1: return <StepBusinessCategory {...stepProps} />;
//             case 2: return <StepBusinessDetails {...stepProps} />;
//             case 3: return <StepBrand {...stepProps} onComplete={onComplete} />;
//             default: return null;
//         }
//     };

//     const hasValue = (value) => {
//         if (value === null || value === undefined) {
//             return false;
//         }

//         if (typeof value === "string") {
//             return value.trim() !== "";
//         }

//         return true;
//     };

//     useEffect(() => {
//         if (!organisationId) return;

//         const fetchData = async () => {
//             setIsFetching(true);

//             try {
//                 const res =
//                     await action.getOrganizationInstruction(
//                         organisationId
//                     );

//                 const existingRecord =
//                     Array.isArray(res?.data)
//                         ? res.data[0]
//                         : Array.isArray(res)
//                             ? res[0]
//                             : res?.data?.[0] || res?.data || res;

//                 if (
//                     existingRecord &&
//                     !existingRecord?.general_error
//                 ) {
//                     setRecordExists(true);

//                     const r = existingRecord;

//                     updateData((prev) => ({
//                         // Keep what the user has already typed.
//                         companyName:
//                             hasValue(prev.companyName)
//                                 ? prev.companyName
//                                 : r.company_name || "",

//                         industry:
//                             hasValue(prev.industry)
//                                 ? prev.industry
//                                 : r.industry || "",

//                         website:
//                             hasValue(prev.website)
//                                 ? prev.website
//                                 : r.website || "",

//                         description:
//                             hasValue(prev.description)
//                                 ? prev.description
//                                 : r.description || "",

//                         logoUrl:
//                             hasValue(prev.logoUrl)
//                                 ? prev.logoUrl
//                                 : r.logo || "",

//                         sector:
//                             hasValue(prev.sector)
//                                 ? prev.sector
//                                 : r.sector || "",

//                         subSector:
//                             hasValue(prev.subSector)
//                                 ? prev.subSector
//                                 : r.sub_sector || "",

//                         category:
//                             hasValue(prev.category)
//                                 ? prev.category
//                                 : r.category || "",

//                         categoryData:
//                             hasValue(prev.categoryData)
//                                 ? prev.categoryData
//                                 : null,

//                         businessType:
//                             hasValue(prev.businessType)
//                                 ? prev.businessType
//                                 : r.business_type || "",

//                         businessTypeData:
//                             hasValue(prev.businessTypeData)
//                                 ? prev.businessTypeData
//                                 : null,

//                         numEmployees:
//                             hasValue(prev.numEmployees)
//                                 ? prev.numEmployees
//                                 : r.number_of_employees ||
//                                 "",

//                         numEmployeesData:
//                             hasValue(prev.numEmployeesData)
//                                 ? prev.numEmployeesData
//                                 : null,

//                         licenseType:
//                             hasValue(prev.licenseType)
//                                 ? prev.licenseType
//                                 : r.license_type ||
//                                 "",

//                         licenseTypeData:
//                             hasValue(prev.licenseTypeData)
//                                 ? prev.licenseTypeData
//                                 : null,

//                         brandColor:
//                             hasValue(prev.brandColor)
//                                 ? prev.brandColor
//                                 : r?.brand_preferences
//                                     ?.brand_color ||
//                                 "#4962E5",

//                         brandFont:
//                             hasValue(prev.brandFont)
//                                 ? prev.brandFont
//                                 : r?.brand_preferences
//                                     ?.brand_font ||
//                                 "",

//                         brandTone:
//                             hasValue(prev.brandTone)
//                                 ? prev.brandTone
//                                 : r?.brand_preferences
//                                     ?.brand_tone ||
//                                 "",

//                         platformIntent:
//                             hasValue(prev.platformIntent)
//                                 ? prev.platformIntent
//                                 : r?.brand_preferences
//                                     ?.platform_intent ||
//                                 "",
//                     }));
//                 } else {
//                     setRecordExists(false);
//                 }
//             } catch (err) {
//                 console.error(err);
//                 setRecordExists(false);
//             } finally {
//                 setIsFetching(false);
//             }
//         };

//         fetchData();
//     }, [organisationId]);

//     return (
//         <Box
//             sx={{
//                 minHeight: "calc(100vh - 90px)",
//                 bgcolor: "grey.50",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 py: 4,
//                 px: 2,
//             }}
//         >
//             <Paper
//                 elevation={0}
//                 sx={{
//                     width: "100%",
//                     maxWidth: 720,
//                     borderRadius: 4,
//                     border: "1px solid",
//                     borderColor: "grey.200",
//                     overflow: "hidden",
//                     bgcolor: "background.paper",
//                 }}
//             >
//                 {/* Header */}
//                 <Box
//                     sx={{
//                         px: 4,
//                         py: 2.5,
//                         borderBottom: "1px solid",
//                         borderColor: "grey.100",
//                         bgcolor: "grey.50",
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1.5,
//                     }}
//                 >
//                     <Box
//                         sx={{
//                             width: 34,
//                             height: 34,
//                             borderRadius: 2,
//                             background: "linear-gradient(135deg, #4962E5, #9B59F5)",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                         }}
//                     >
//                         <AutoAwesomeIcon sx={{ color: "white", fontSize: 17 }} />
//                     </Box>
//                     <Typography variant="overline" fontWeight={700} color="text.secondary" letterSpacing="0.12em">
//                         Workspace Setup
//                     </Typography>
//                 </Box>

//                 {/* Stepper */}
//                 <Box sx={{ px: 4, pt: 3, pb: 1 }}>
//                     <Stepper activeStep={activeStep} alternativeLabel>
//                         {STEPS.map((label) => (
//                             <Step key={label}>
//                                 <StepLabel>{label}</StepLabel>
//                             </Step>
//                         ))}
//                     </Stepper>
//                 </Box>

//                 {/* Step Content */}
//                 <Box sx={{ px: 4, pt: 3, pb: 5 }}>
//                     {renderStep()}
//                 </Box>
//             </Paper>
//         </Box>
//     );
// }


import { useEffect, useState } from "react";
import {
    Box,
    Stepper,
    Step,
    StepLabel,
} from "@mui/material";
import StepCompanyDetails from "./StepCompanyDetails.tsx";
import StepBusinessCategory from "./StepBusinessCategory.tsx";
import StepBusinessDetails from "./StepBusinessDetails.tsx";
import { AiActions } from "../../Services/_actions/index.js";
import { useNavigate } from "react-router";
const STEPS = ["Company Details", "Business Category", "Business Details",];

const INITIAL_DATA = {
    companyName: "",
    industry: "",
    website: "",
    description: "",
    logoPreview: null,
    logoUrl: null,
    sector: null,
    sectorId: null,
    subSector: null,
    subSectorId: null,
    category: null,
    businessType: null,
    numEmployees: null,
    licenseType: null,
    endCustomerType: null,
    brandColor: "#4962E5",
    brandFont: "",
    brandTone: null,
    platformIntent: "",
};

export default function MachadaloStudioDashboard({ onComplete }) {
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState(INITIAL_DATA);
    const [isFetching, setIsFetching] = useState(false);
    const action = AiActions();
    const [recordExists, setRecordExists] = useState(null);
    const userInfo =
        localStorage.getItem("userInfo");

    const parsedUser = userInfo
        ? JSON.parse(userInfo)
        : null;

    const organisationId =
        parsedUser?.profile?.organisation
            ?.organisation_id || "";

    const updateData = (fields) =>
        setFormData((prev) => {
            const nextFields =
                typeof fields === "function"
                    ? fields(prev)
                    : fields;

            return { ...prev, ...nextFields };
        });
    const next = () => setActiveStep((s) => s + 1);
    const back = () => setActiveStep((s) => s - 1);

    const stepProps = {
        formData,
        updateData,
        onNext: next,
        onBack: back,
        isFetching,
        recordExists,
        setRecordExists,
    };

    const renderStep = () => {
        switch (activeStep) {
            case 0: return <StepCompanyDetails {...stepProps} />;
            case 1: return <StepBusinessCategory {...stepProps} />;
            case 2: return <StepBusinessDetails {...stepProps} onNext={() => {
                if (onComplete) {
                    onComplete();
                } else {
                    next();
                }
            }} />;
            default: return null;
        }
    };

    const hasValue = (value) => {
        if (value === null || value === undefined) {
            return false;
        }

        if (typeof value === "string") {
            return value.trim() !== "";
        }

        return true;
    };

    useEffect(() => {
        if (!organisationId) return;

        const fetchData = async () => {
            setIsFetching(true);

            try {
                const res =
                    await action.getOrganizationInstruction(
                        organisationId
                    );

                const existingRecord =
                    Array.isArray(res?.data)
                        ? res.data[0]
                        : Array.isArray(res)
                            ? res[0]
                            : res?.data?.[0] || res?.data || res;

                if (
                    existingRecord &&
                    !existingRecord?.general_error
                ) {
                    setRecordExists(true);

                    const r = existingRecord;

                    updateData((prev) => ({
                        // Keep what the user has already typed.
                        companyName:
                            hasValue(prev.companyName)
                                ? prev.companyName
                                : r.company_name || "",

                        industry:
                            hasValue(prev.industry)
                                ? prev.industry
                                : r.industry || "",

                        website:
                            hasValue(prev.website)
                                ? prev.website
                                : r.website || "",

                        description:
                            hasValue(prev.description)
                                ? prev.description
                                : r.description || "",

                        logoUrl:
                            hasValue(prev.logoUrl)
                                ? prev.logoUrl
                                : r.logo || "",

                        sector:
                            hasValue(prev.sector)
                                ? prev.sector
                                : r.sector || "",

                        subSector:
                            hasValue(prev.subSector)
                                ? prev.subSector
                                : r.sub_sector || "",

                        category:
                            hasValue(prev.category)
                                ? prev.category
                                : r.category || "",

                        categoryData:
                            hasValue(prev.categoryData)
                                ? prev.categoryData
                                : null,

                        businessType:
                            hasValue(prev.businessType)
                                ? prev.businessType
                                : r.business_type || "",

                        businessTypeData:
                            hasValue(prev.businessTypeData)
                                ? prev.businessTypeData
                                : null,

                        numEmployees:
                            hasValue(prev.numEmployees)
                                ? prev.numEmployees
                                : r.number_of_employees ||
                                "",

                        numEmployeesData:
                            hasValue(prev.numEmployeesData)
                                ? prev.numEmployeesData
                                : null,

                        licenseType:
                            hasValue(prev.licenseType)
                                ? prev.licenseType
                                : r.license_type ||
                                "",

                        licenseTypeData:
                            hasValue(prev.licenseTypeData)
                                ? prev.licenseTypeData
                                : null,

                        brandColor:
                            hasValue(prev.brandColor)
                                ? prev.brandColor
                                : r?.brand_preferences
                                    ?.brand_color ||
                                "#4962E5",

                        brandFont:
                            hasValue(prev.brandFont)
                                ? prev.brandFont
                                : r?.brand_preferences
                                    ?.brand_font ||
                                "",

                        brandTone:
                            hasValue(prev.brandTone)
                                ? prev.brandTone
                                : r?.brand_preferences
                                    ?.brand_tone ||
                                "",

                        platformIntent:
                            hasValue(prev.platformIntent)
                                ? prev.platformIntent
                                : r?.brand_preferences
                                    ?.platform_intent ||
                                "",
                    }));
                } else {
                    setRecordExists(false);
                }
            } catch (err) {
                console.error(err);
                setRecordExists(false);
            } finally {
                setIsFetching(false);
            }
        };

        fetchData();
    }, [organisationId]);

    return (
        <Box
            sx={{
                bgcolor: "grey.50",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pt: 2,
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    overflow: "hidden",
                }}
            >
                {/* Stepper */}
                <Box sx={{ px: 4, pb: 1 }}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {STEPS.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>

                {/* Step Content */}
                <Box sx={{ px: 4, pb: 5 }}>
                    {renderStep()}
                </Box>
            </Box>
        </Box>
    );
}